import { CircularProgress, FormControl, Grid, TextField, Typography } from '@mui/material';
import React from 'react';
import { Controller, DeepPartial, useForm, UseFormReturn } from 'react-hook-form';
import {
  CreateTenantWorkOrderSubmissionRequest,
  TenantWorkOrderSubmission,
  UpdateTenantWorkOrderSubmissionRequest,
} from 'vendor-marketplace-shared-library';

import Button from '../../../../components/common/styled-mui-overrides/Button';
import theme from '../../../../utilities/theme';

type TenantCreateSubmissionFormProps = {
  onSubmit: (
    data: CreateTenantWorkOrderSubmissionRequest | UpdateTenantWorkOrderSubmissionRequest,
  ) => void;
  tenantWorkOrderSubmission: TenantWorkOrderSubmission | null;
  isLoading: boolean;
  isError: boolean;
};

const TenantWorkOrderDetailsSubmissionForm = (props: TenantCreateSubmissionFormProps) => {
  const form: UseFormReturn<
    CreateTenantWorkOrderSubmissionRequest | UpdateTenantWorkOrderSubmissionRequest
  > = useForm({
    defaultValues: {
      description: props.tenantWorkOrderSubmission?.description || '',
      propertyLocation: props.tenantWorkOrderSubmission?.propertyLocation || '',
    } as DeepPartial<any>,
  });

  return (
    <form onSubmit={form.handleSubmit(props.onSubmit)}>
      <Grid container sx={styles.mainContainer}>
        <Grid item>
          <Typography variant='h5' fontWeight='bold'>
            What needs fixing?
          </Typography>
        </Grid>
        <Grid item sx={styles.fullWidth}>
          <Controller
            name={'description'}
            control={form.control}
            render={({ field }) => {
              return (
                <FormControl fullWidth>
                  <Grid container>
                    <Grid item>
                      <Typography variant='subtitle2'>Describe issue</Typography>
                    </Grid>
                    <Grid item>
                      <Typography variant='subtitle2' color='error'>
                        {' *'}
                      </Typography>
                    </Grid>
                  </Grid>
                  <TextField
                    label=''
                    size='small'
                    required
                    inputProps={{ 'aria-label': 'Without label' }}
                    placeholder="Ex: My unit door is jammed and won't open"
                    multiline
                    rows={4}
                    {...field}
                  />
                </FormControl>
              );
            }}
          />
        </Grid>

        <Grid item sx={styles.fullWidth}>
          <Grid container sx={styles.inputContainer}>
            <Grid item>
              <Controller
                name='propertyLocation'
                control={form.control}
                render={({ field }) => {
                  return (
                    <FormControl fullWidth>
                      <Grid container>
                        <Grid item>
                          <Typography variant='subtitle2'>Where is it? </Typography>
                        </Grid>
                        <Grid item>
                          <Typography variant='subtitle2' color='error'>
                            {' *'}
                          </Typography>
                        </Grid>
                      </Grid>
                      <TextField
                        label=''
                        size='small'
                        required
                        inputProps={{ 'aria-label': 'Without label' }}
                        placeholder='Ex: Unit number, or common area...'
                        {...field}
                      />
                    </FormControl>
                  );
                }}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item sx={styles.pageContainer}>
          <Typography sx={styles.greyText} variant='caption'>
            1/3
          </Typography>
        </Grid>

        <Grid item sx={styles.buttonContainer}>
          <Button type='submit'>
            {props.isLoading && !props.isError ? (
              <CircularProgress size={20} color={'inherit'} />
            ) : props.tenantWorkOrderSubmission?.id ? (
              'Next'
            ) : (
              'Get Started'
            )}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default TenantWorkOrderDetailsSubmissionForm;

const styles = {
  mainContainer: {
    flexDirection: 'column',
    rowGap: 4,
    alignItems: 'center',
    flex: 1,
  },
  fullWidth: {
    width: '100%',
  },
  inputContainer: {
    flexDirection: 'column',
    rowGap: 1,
  },
  pageContainer: {
    paddingTop: 4,
  },
  greyText: {
    color: theme.palette.secondary.main,
  },
  buttonContainer: {
    width: '60%',
  },
};
